import React, { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Grid } from "@mui/material";
import { Card, CardContent, Typography, Divider, Chip } from "@mui/material";
import { useAlerta } from "utils/alertas";
import ModalSeleccionMetodoPago from "./ModalSeleccionMetodoPago";
import ModalEditarCostos from "./ModalEditarCostos";

export default function PagosDeudas() {
  const [busqueda, setBusqueda] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [cuotasPendientes, setCuotasPendientes] = useState([]);
  const [cuotaSeleccionada, setCuotaSeleccionada] = useState("");
  const [observacionesPago, setObservacionesPago] = useState("");
  const [openEditarCostos, setOpenEditarCostos] = useState(false);
  const [pagos, setPagos] = useState([]);
  const [resumen, setResumen] = useState({
    total_pagado: 0,
    total_deuda: 0,
  });
  const [deudores, setDeudores] = useState([]);
  const [modoDeudores, setModoDeudores] = useState(false);
  const usuario = JSON.parse(sessionStorage.getItem("user"));
  const puedeEliminarPago = [1, 2, 6].includes(usuario?.rol);
  const puedeEditarCostos = [1, 2, 6].includes(usuario?.rol);
  const [openPago, setOpenPago] = useState(false);
  const [montoPago, setMontoPago] = useState("");
  const [metodoPago, setMetodoPago] = useState("");
  const [conceptoPago, setConceptoPago] = useState("");
  const [otrosCobros, setOtrosCobros] = useState([]);
  const detallesRef = React.useRef(null);
  const [pagoEfectivo, setPagoEfectivo] = useState("");
  const [tipoPagoExtra, setTipoPagoExtra] = useState("");
  const [observacionPago, setObservacionPago] = useState("");
  const [pagoQr, setPagoQr] = useState("");
  const [descuentoPago, setDescuentoPago] = useState("");
  const [openNuevoPago, setOpenNuevoPago] = useState(false);
  const [nuevoCosto, setNuevoCosto] = useState("");
  const [nuevoMontoEfectivo, setNuevoMontoEfectivo] = useState("");
  const [openMetodoPagoModal, setOpenMetodoPagoModal] = useState(false);
  const [nuevoMontoQr, setNuevoMontoQr] = useState("");
  const [nuevoConcepto, setNuevoConcepto] = useState("");
  const [nuevoMonto, setNuevoMonto] = useState("");
  const { mostrarAlerta } = useAlerta();
  const limpiarModalPago = () => {
    setMontoPago("");
    setCuotaSeleccionada("");
    setMetodoPago("");
    setObservacionesPago("");
  };
const meses = [
  "",
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];
  const token = sessionStorage.getItem("access_token");
  const [numeroCuotas, setNumeroCuotas] = useState("");
  const [cobroSeleccionado, setCobroSeleccionado] = useState(null);

  // 🔍 Buscar usuarios
  useEffect(() => {
    if (busqueda.length < 2) return;

    fetch(`${process.env.REACT_APP_API_URL}/usuarios/buscar/${busqueda}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then(res => res.json())
      .then(data => {
        setUsuarios(Array.isArray(data) ? data : data.usuarios || []);
      })
      .catch(err => console.error(err));
  }, [busqueda]);
useEffect(() => {
    const fetchOtrosCobros = async () => {
      const token = sessionStorage.getItem("access_token");

      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/items`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const data = await res.json();
        // solo activos
        setOtrosCobros(data.filter(c => c.estado === 1));
      } catch (err) {
        console.error("Error al cargar otros cobros:", err);
      } 
    };

    fetchOtrosCobros();
  }, []);
  const abrirModalPago = (usuario) => {
    limpiarModalPago();
    fetch(`${process.env.REACT_APP_API_URL}/usuarios/${usuarioSeleccionado.id}/cuotas`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then(res => res.json())
      .then(data => {
        setCuotasPendientes(Array.isArray(data) ? data : data.data || []);
        setOpenPago(true);
      });

  };
  useEffect(() => {
  if (openNuevoPago) {
    setTipoPagoExtra("");
    setNuevoConcepto("");
    setNuevoCosto("");
    setNuevoMonto("");
    setNuevoMontoEfectivo("");
    setNuevoMontoQr("");
    setObservacionPago("");
    setNumeroCuotas("");
    setCobroSeleccionado(null);
    setMetodoPago("");
  }
}, [openNuevoPago]);
  const guardarNuevoPago = () => {
    let montoFinal = Number(nuevoMonto);
    let pago_efectivo = 0;
    let pago_qr = 0;

    if (metodoPago === "MIXTO") {
      pago_efectivo = Number(nuevoMontoEfectivo) || 0;
      pago_qr = Number(nuevoMontoQr) || 0;
      montoFinal = pago_efectivo + pago_qr;
    } else if (metodoPago === "EFECTIVO") {
      pago_efectivo = montoFinal;
    } else if (metodoPago === "QR") {
      pago_qr = montoFinal;
    }
    const payload = {
      otro_cobro_id: tipoPagoExtra === "OTROS_COBROS" ? Number(nuevoConcepto) : null,
      tipo: tipoPagoExtra,
      costo: Number(nuevoCosto),
      monto_pagado: Number(nuevoMonto),
      metodo: metodoPago,
      pago_efectivo,
      pago_qr,
      observacion: observacionPago, 
      numero_cuotas:
      cobroSeleccionado?.tipo_cobro?.toLowerCase() === "mensual"
        ? Number(numeroCuotas)
        : null,
    };


    fetch(`${process.env.REACT_APP_API_URL}/usuarios/${usuarioSeleccionado.id}/nuevo-pago`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(() => {
        mostrarAlerta("Pago registrado correctamente", "success");
        console.log(payload);
        setOpenNuevoPago(false);
        cargarPagos(usuarioSeleccionado);
      })
      .catch(() => {
        mostrarAlerta("Error al registrar pago", "error");
      });
  };
  const cargarPagos = (usuario) => {
    setUsuarioSeleccionado(usuario);
    setBusqueda("");
    setUsuarios([]);

    fetch(`${process.env.REACT_APP_API_URL}/usuarios/${usuario.id}/pagos-deudas`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then(res => res.json())
      .then(data => {
        console.log(data.pagos);
        setPagos(Array.isArray(data.pagos) ? data.pagos : []);
        setResumen({
          total_pagado: data.total_pagado || 0,
          total_deuda: data.total_deuda || 0,
          pagos_matricula: data.pagos_matricula || [],
          pagos_mensualidad: data.pagos_mensualidad || [],
          otros_cobros: data.otros_cobros || [],
          costo_matricula: data.costo_matricula || 0,
          costo_mensualidad: data.costo_mensualidad || 0,
        });
      });
      setModoDeudores(false);
  };
  const cargarDeudores = () => {
  fetch(`${process.env.REACT_APP_API_URL}/deudores`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  })
    .then(res => res.json())
    .then(data => {
      console.log("DATA QUE LLEGA:", data);
      setDeudores(data);
      setModoDeudores(true);
      setUsuarioSeleccionado(null);
      setBusqueda("");
    })
    .catch(err => console.error(err));
};

  const columns = [
    { Header: "Fecha", accessor: "fecha_pago" },
    { 
      Header: "Concepto", 
      accessor: "tipo", // Mantenemos el accessor base
      Cell: ({ row }) => {
        const { tipo, descripcion } = row.original;
        
        // 🔥 Si es un cobro extra, priorizamos la descripción
        if (tipo === "otros_cobros" || tipo === "otro_cobro") {
          return descripcion || "Otro Cobro"; 
        }

        // Si es matricula o mensualidad, capitalizamos la primera letra para que se vea mejor
        return tipo ? tipo.charAt(0).toUpperCase() + tipo.slice(1) : "-";
      }
    },
    { Header: "Pagado", accessor: "monto_pagado" },
    {
      Header: "Cuota",
      accessor: "numero_cuota",
      Cell: ({ value }) => value
    },
    {
      Header: "Observaciones",
      accessor: "observaciones",
    },
    ...(puedeEliminarPago
    ? [
        {
          Header: "Acciones",
          accessor: "acciones",
          Cell: ({ row }) => (
            <MDButton
              color="error"
              size="small"
              onClick={() => eliminarPago(row.original.pago_id, row.original.tipo)}
            >
              Eliminar pago
            </MDButton>
          ),
        },
      ]
    : []),
  ];
  const eliminarPago = async (pago_id, tipo) => {
    //console.log("Pago a eliminar:", pago_id, tipo );

    if (!window.confirm("¿Está seguro de eliminar este pago?")) {
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/pagos/${pago_id}/${tipo}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error");
      }

      mostrarAlerta("Pago eliminado correctamente", "success");

      cargarPagos(usuarioSeleccionado);
    } catch (error) {
      console.error(error);
      mostrarAlerta(error.message, "error");
    }
  };
  const columnasDeudores = [
    { Header: "Codigo", accessor: "codigo" },
    { Header: "Nombre", accessor: "nombre_completo" },
    { Header: "Email", accessor: "email" },
    { Header: "Total deuda", accessor: "total_deuda" },
    { Header: "Estado", accessor: "estado" },
  ];

  // 💸 Registrar pago
  const registrarPago = () => {
    let finalMonto = Number(montoPago);
    let finalEfe = 0;
    let finalQr = 0;
    const finalDescuento = Number(descuentoPago) || 0;

    if (!metodoPago) {
      setOpenMetodoPagoModal(true);
      return;
    }
    if (metodoPago === "MIXTO") {
      finalEfe = Number(pagoEfectivo) || 0;
      finalQr = Number(pagoQr) || 0;
      finalMonto = finalEfe + finalQr;

      if (finalMonto <= 0) {
        mostrarAlerta("Debes colocar un monto válido en Efectivo o en QR.", "error");
        return;
      }
      
      const cuotaActual = cuotasPendientes.find((c) => c.cuota_id == cuotaSeleccionada);
      if (cuotaActual && finalMonto > Number(cuotaActual.saldo)) {
        mostrarAlerta(`La suma de ambos pagos (Bs ${finalMonto}) supera el saldo permitido (Bs ${cuotaActual.saldo})`, "error");
        return;
      }
    } else if (metodoPago === "EFECTIVO") {
      finalEfe = finalMonto;
    } else if (metodoPago === "QR") {
      finalQr = finalMonto;
    }

    const payload = {
      monto: finalMonto,
      metodo: metodoPago,
      cuota_id: Number(cuotaSeleccionada),
      pago_efectivo: finalEfe,
      pago_qr: finalQr,
      descuento: finalDescuento,
      observacion_pago: observacionesPago
    };

    console.log("📤 Enviando a Laravel:", payload);

    fetch(`${process.env.REACT_APP_API_URL}/usuarios/${usuarioSeleccionado.id}/pagos`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        mostrarAlerta("Pago registrado con éxito", "success");
        setOpenPago(false);
        cargarPagos(usuarioSeleccionado); // refresca pagos y resumen
        limpiarModalPago();
      })
      .catch((err) => {
        console.error(err);
        mostrarAlerta("Ocurrió un error al registrar el pago.", "error");
      });
  };

  return (
    <Box>
      <ModalSeleccionMetodoPago
        open={openMetodoPagoModal}
        onClose={() => setOpenMetodoPagoModal(false)}
        onSelect={(metodo) => setMetodoPago(metodo)}
      />
      {/* Buscador */}
      <Card sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <TextField
            label="Buscar estudiante por nombre, CI, codigo"
            value={busqueda}
            onChange={(e) => {
              const value = e.target.value;
              setBusqueda(value);
              if (value.trim() === "") {
                setUsuarios([]);
                setUsuarioSeleccionado(null);
                setPagos([]);
                setResumen({ total_pagado: 0, total_deuda: 0 });
                setDeudores([]);
                setModoDeudores(false);
              }
            }}
            fullWidth
          />
          <MDButton color="warning" onClick={cargarDeudores}>
            Deudores
          </MDButton>
        </Box>
      </Card>

      {/* Lista búsqueda */}
      <Box sx={{ mb: 2 }}>
        {busqueda.trim() !== "" && usuarios.map(u => (
          <Card
            key={u.id}
            sx={{
              p: 1.5,
              mb: 1,
              cursor: "pointer",
              bgcolor: "#ffffff",
              transition: "0.2s",
              "&:hover": { boxShadow: 3, bgcolor: "#f5faff" }
            }}
            onClick={() => cargarPagos(u)}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography fontWeight="bold">
                {u.codigo_estudiante} {u.name} {u.apellido_paterno || ""} {u.apellido_materno || ""}
              </Typography>
              <Typography variant="caption">{u.email}</Typography>
            </Box>
          </Card>
        ))}
      </Box>

      {/* Tabla de deudores */}
      {modoDeudores && deudores.length > 0 && (
        <Card sx={{ p: 2, "& .MuiTable-root": { fontSize: 16 } }}>
          <Typography variant="h6" mb={1} align="center">
            Estudiantes con deuda
          </Typography>
          <Divider sx={{ mb: 1 }} />

          <Box
            sx={{
              width: "100%",
              maxWidth: {
                xs: "100%",   // 📱 celular
                sm: "100%",   // tablet
                md: 900,      // 💻 laptop
                lg: 1100,     // 🖥️ grande (como lo tienes)
              },
              mx: "auto",
            }}
          >
            <DataTable
              table={{ columns: columnasDeudores, rows: deudores }}
              entriesPerPage={false}
            />
          </Box>
        </Card>
      )}

      {/* Detalle usuario */}
      {usuarioSeleccionado && (
        <>
          <Card sx={{ p: 2, mb: 2 }}>
            <Typography variant="h5">
              {usuarioSeleccionado.codigo_estudiante} {usuarioSeleccionado.name} {usuarioSeleccionado.apellido_paterno} {usuarioSeleccionado.apellido_materno}
            </Typography>
            <Divider sx={{ my: 1 }} />

            <Box sx={{ display: "flex", gap: 3, mb: 1, flexWrap: "wrap",}}>
              <Chip
                label={`Total pagado: Bs ${resumen.total_pagado}`}
                sx={{
                  bgcolor: "#e8f5e9",
                  color: "#2e7d32",
                  fontWeight: "bold",
                  fontSize: 18,
                }}
              />
              <Chip
                label={`Deuda pendiente: Bs ${resumen.total_deuda}`}
                sx={{
                  bgcolor: "#fbe9e7",
                  color: "#c62828",
                  fontWeight: "bold",
                  fontSize: 18,
                }}
              />
              {/* Matrícula */}
              <Chip
                 label={`Costo Matrícula: Bs ${resumen.costo_matricula ?? 0}`}
                sx={{
                  bgcolor: "#e3f2fd", // azul pastel
                  color: "#1565c0",
                  fontWeight: "bold",
                  fontSize: 18
                }}
              />

              {/* Mensualidad */}
              <Chip
                label={`Costo Mensualidad: Bs ${resumen.costo_mensualidad ?? 0}`}
                sx={{
                  bgcolor: "#f3e5f5", // lila pastel
                  color: "#6a1b9a",
                  fontWeight: "bold",
                  fontSize: 18
                }}
              />
              {resumen.otros_cobros?.map((oc, index) => (
                <Box key={index} sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {
                    [...new Map(
                      oc.items.map(item => [
                        item.descripcion + "_" + item.costo, // 🔑 clave única
                        item
                      ])
                    ).values()].map((c, i) => (
                      <Chip
                        key={i}
                        label={`${c.descripcion}: Bs ${c.costo}`}
                        sx={{
                          bgcolor: "#fff3e0",
                          color: "#ef6c00",
                          fontWeight: "bold",
                          fontSize: 16
                        }}
                      />
                    ))
                  }
                </Box>
              ))}
            </Box>
              <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                <MDButton
                  color="success"
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                  onClick={() => abrirModalPago(usuarioSeleccionado)}
                >
                  Registrar pago
                </MDButton>

                <MDButton
                  color="warning"
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                  onClick={() => setOpenNuevoPago(true)}
                >
                  Añadir nuevo pago
                </MDButton>
                {puedeEditarCostos && (
                  <MDButton
                    color="info"
                    onClick={() => setOpenEditarCostos(true)}
                  >
                    Editar costos
                  </MDButton>
                )}
              </Box>
          </Card>

          {pagos.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Card sx={{ p: 2, width: "100%", maxWidth: 900 }}>
                <Typography variant="h6" align="center">
                  Historial de pagos
                </Typography>
                <Divider sx={{ mb: 1 }} />
                <DataTable table={{ columns, rows: pagos }} entriesPerPage={false} />
              </Card>
            </Box>
          )}

          {/* Modal */}
          <Dialog open={openPago} onClose={() => setOpenPago(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Registrar Pago</DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={2}>
                
                {/* 🔥 GRUPO 1: Monto y Descuento lado a lado */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    
                    <Grid item xs={6}>
                      {metodoPago === "MIXTO" ? (
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              label="Monto Efectivo"
                              type="number"
                              fullWidth
                              value={pagoEfectivo}
                              onChange={(e) => setPagoEfectivo(e.target.value)}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label="Monto QR"
                              type="number"
                              fullWidth
                              value={pagoQr}
                              onChange={(e) => setPagoQr(e.target.value)}
                            />
                          </Grid>
                        </Grid>
                      ) : (
                        <TextField
                          label="Monto a Pagar (Dinero real)"
                          type="number"
                          fullWidth
                          value={montoPago}
                          onChange={(e) => setMontoPago(e.target.value)} // Permite sobreescribir si quieren pagar menos del saldo restante
                        />
                      )}
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Descuento adicional (Bs)"
                        type="number"
                        fullWidth
                        value={descuentoPago}
                        onChange={(e) => {
                          const valorDescuento = parseFloat(e.target.value) || 0;
                          setDescuentoPago(e.target.value);

                          // 🔍 Buscamos la cuota seleccionada para saber cuánto debe
                          const cuotaActual = cuotasPendientes.find((c) => c.cuota_id == cuotaSeleccionada);

                          if (cuotaActual) {
                            if (valorDescuento > Number(cuotaActual.saldo)) {
                              mostrarAlerta("El descuento no puede ser mayor al saldo de la cuota", "error");
                              return;
                            }

                            // 🔥 LA MAGIA DINÁMICA: Calculamos lo que sobra por pagar en efectivo/qr
                            const saldoRestanteReal = Number(cuotaActual.saldo) - valorDescuento;
                            
                            // Seteamos el monto automáticamente en la caja de la izquierda
                            setMontoPago(saldoRestanteReal.toFixed(2)); 
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* 🔥 GRUPO 2: Cuota a pagar y Método de pago lado a lado */}
                <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Cuota a pagar"
                    value={cuotaSeleccionada}
                    SelectProps={{ native: true }}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      setCuotaSeleccionada(selectedId);
                      const cuota = cuotasPendientes.find((c) => c.cuota_id == selectedId);

                      if (cuota) {
                        const fechaLimpia = cuota.fecha_vencimiento.split(" ")[0];
                        const [year, month, day] = fechaLimpia.split("-");
                        const hoy = new Date();
                        const fechaVencimiento = new Date(year, month - 1, day);
                        hoy.setHours(0, 0, 0, 0);
                        fechaVencimiento.setHours(0, 0, 0, 0);

                        if (fechaVencimiento < hoy && Number(cuota.descuento) > 0) {
                          mostrarAlerta(`La cuota venció el ${fechaLimpia}. Se anula el descuento de Bs ${cuota.descuento}.`, "warning");
                          const saldoSinDescuento = Number(cuota.saldo) + Number(cuota.descuento);
                          setMontoPago(saldoSinDescuento.toFixed(2));
                        } else {
                          setMontoPago(cuota.saldo);
                        }
                      } else {
                        setMontoPago("");
                      }
                    }}
                  >
                    <option value=""></option>
                    {cuotasPendientes.map((c) => {
                      // 🔢 Extraemos el número de cuota, si no existe ponemos un guion o 0
                      const num = c.numero_cuota || "0";
                      
                      // 🏷️ Determinamos el concepto (Mensualidad, Matrícula o Descripción)
                      let concepto = "";
                      if (c.tipo === "mensualidad") concepto = "Mensualidad";
                      else if (c.tipo === "matricula") concepto = "Matrícula";
                      else concepto = c.descripcion || "Cobro Extra";

                      const fuente = c.fuente ? c.fuente.charAt(0).toUpperCase() + c.fuente.slice(1) : "General";
                      const gestion = c.gestion || c.anio || "S/G";
                      const grupo = c.grupo ? `- ${c.grupo}` : "";

                      return (
                        <option key={c.cuota_id} value={c.cuota_id}>
                          {/* 🔥 Formato: Cuota 1: Mensualidad | Saldo: Bs 500 ... */}
                          {`Cuota ${num}: ${concepto} | Saldo: Bs ${c.saldo} | ${fuente} (${gestion}) ${grupo}`}
                        </option>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    SelectProps={{ native: true }}
                    value={metodoPago}
                    label="Método de pago"
                    onChange={(e) => setMetodoPago(e.target.value)}
                  >
                    <option value=""></option>
                    <option value="QR">Pago por QR</option>
                    <option value="EFECTIVO">Pago en efectivo</option>
                    <option value="MIXTO">Pago Mixto (Efectivo y QR)</option>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Observaciones"
                    fullWidth
                    multiline
                    rows={3}
                    value={observacionesPago}
                    onChange={(e) => setObservacionesPago(e.target.value)}
                    placeholder="Escriba alguna observación del pago..."
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <MDButton color="info" onClick={registrarPago}>Guardar</MDButton>
              <MDButton color="error" onClick={() => setOpenPago(false)}>Cancelar</MDButton>
            </DialogActions>
          </Dialog>
          <Dialog open={openNuevoPago} onClose={() => setOpenNuevoPago(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Nuevo Pago</DialogTitle>

            <DialogContent dividers>
              <Grid container spacing={2}>
                  
                  <Grid item xs={6}>
                    <TextField
                      select
                      fullWidth
                      label="Tipo de pago"
                      value={tipoPagoExtra}
                      onChange={(e) => setTipoPagoExtra(e.target.value)}
                      SelectProps={{ native: true }}
                    >
                      <option value=""></option>
                      <option value="OTROS_COBROS">Otros cobros</option>
                      <option value="OTROS">Otros (manual)</option>
                    </TextField>
                  </Grid>
                {tipoPagoExtra === "OTROS_COBROS" && (
                  <Grid item xs={6}>
                    <TextField
                      select
                      fullWidth
                      label="Tipo de cobro"
                      value={nuevoConcepto} 
                      onChange={(e) => {
                        const id = e.target.value;
                        setNuevoConcepto(id);

                        const cobro = otrosCobros.find(c => c.id == id);
                        setCobroSeleccionado(cobro || null);
                      }}
                      SelectProps={{ native: true }}
                    >
                      <option value=""></option>
                      {otrosCobros.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.concepto}
                        </option>
                      ))}
                    </TextField>
                  </Grid>
                  
                )}
                {cobroSeleccionado?.tipo_cobro === "mensual" && (
                  <Grid item xs={12}>
                    <TextField
                      label="Número de cuotas"
                      type="number"
                      fullWidth
                      value={numeroCuotas}
                      onChange={(e) => setNumeroCuotas(e.target.value)}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Observación"
                    value={observacionPago}
                    onChange={(e) => setObservacionPago(e.target.value)}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label="Costo total"
                    type="number"
                    fullWidth
                    value={nuevoCosto}
                    onChange={(e) => setNuevoCosto(e.target.value)}
                  />
                </Grid>

                {metodoPago === "MIXTO" ? (
                  <>
                    <Grid item xs={6}>
                      <TextField
                        label="Monto Efectivo"
                        type="number"
                        fullWidth
                        value={nuevoMontoEfectivo}
                        onChange={(e) => setNuevoMontoEfectivo(e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Monto QR"
                        type="number"
                        fullWidth
                        value={nuevoMontoQr}
                        onChange={(e) => setNuevoMontoQr(e.target.value)}
                      />
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={6}>
                    <TextField
                      label="Monto pagado"
                      type="number"
                      fullWidth
                      value={nuevoMonto}
                      onChange={(e) => setNuevoMonto(e.target.value)}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    SelectProps={{ native: true }}
                    value={metodoPago}
                    label="Método de pago"
                    onChange={(e) => setMetodoPago(e.target.value)}
                  >
                    <option value=""></option>
                    <option value="QR">QR</option>
                    <option value="EFECTIVO">Efectivo</option>
                    <option value="MIXTO">Mixto</option>
                  </TextField>
                </Grid>

              </Grid>
            </DialogContent>

            <DialogActions>
              <MDButton color="info" onClick={guardarNuevoPago}>
                Guardar
              </MDButton>
              <MDButton color="error" onClick={() => setOpenNuevoPago(false)}>
                Cancelar
              </MDButton>
            </DialogActions>
          </Dialog>
          <ModalEditarCostos
            open={openEditarCostos}
            onClose={() => setOpenEditarCostos(false)}
            usuarioId={usuarioSeleccionado?.id}
            onActualizado={() => cargarPagos(usuarioSeleccionado)}
          />
        </>
      )}
    </Box>
  );
}
